export default "__VITE_ASSET__jvGgwdnM__"